// Copyright (c) 2025 Nebularis Holdings LLC
// Licensed to Nutrx Solutions under a non-exclusive, non-transferable license.
// See IP License Agreement for usage restrictions.
// frontend/src/components/enterprise-admin/audit/GovernanceEventFilters.jsx

import React from "react";
import { Button, Field, Select, TextInput } from "../../../design-system/components";

export default function GovernanceEventFilters({ categories = [], filters, onChange, onExport, saving }) {
  const update = (key, value) => onChange?.({ ...filters, [key]: value });
  const hasFilters = Boolean(filters.q || filters.category || filters.severity);

  return (
    <section className="enterprise-admin-form-card enterprise-admin-governance-filters">
      <div className="enterprise-admin-card-heading">
        <p className="enterprise-admin-eyebrow">Traceability Filters</p>
        <h3>Find administrative evidence fast</h3>
        <p>Filter the governance ledger by category, severity, or free-text search.</p>
      </div>

      <div className="enterprise-admin-governance-filter-grid">
        <Field label="Search">
          {({ id, "aria-describedby": ariaDescribedBy }) => (
            <TextInput
              id={id}
              aria-describedby={ariaDescribedBy}
              value={filters.q || ""}
              placeholder="Search action, actor, target, connector, or role"
              onChange={(event) => update("q", event.target.value)}
            />
          )}
        </Field>

        <Field label="Category">
          {({ id, "aria-describedby": ariaDescribedBy }) => (
            <Select id={id} aria-describedby={ariaDescribedBy} value={filters.category || ""} onChange={(event) => update("category", event.target.value)}>
              <option value="">All categories</option>
              {categories.map((category) => <option key={category.key} value={category.key}>{category.label}</option>)}
            </Select>
          )}
        </Field>

        <Field label="Severity">
          {({ id, "aria-describedby": ariaDescribedBy }) => (
            <Select id={id} aria-describedby={ariaDescribedBy} value={filters.severity || ""} onChange={(event) => update("severity", event.target.value)}>
              <option value="">All severities</option>
              <option value="info">Info</option>
              <option value="notice">Notice</option>
              <option value="warning">Warning</option>
              <option value="critical">Critical</option>
            </Select>
          )}
        </Field>

        <div className="enterprise-admin-governance-filter-actions">
          <Button type="button" variant="secondary" disabled={!hasFilters || saving} onClick={() => onChange?.({ q: "", category: "", severity: "" })}>Clear</Button>
          <Button type="button" disabled={saving} onClick={onExport}>{saving ? "Preparing export…" : "Export ledger"}</Button>
        </div>
      </div>
    </section>
  );
}
